import { IconBooks } from '@tabler/icons';

const icons = { IconBooks };

const vmaServices = {
    id: 'allVmaServices',
    type: 'group',
    children: [
        {
            id: 'vmaServices',
            type: 'collapse',
            title: 'VMA paslaugos',
            icon: icons.IconBooks,
            
            children: [
                {
                    id: 'moodle',
                    title: 'Moodle',
                    type: 'item',
                    url: '/vma-paslaugos/moodle'
                },
                {
                    id: 'videoStorage',
                    title: 'Vaizdo įrašų saugojimas',
                    type: 'item',
                    url: '/vma-paslaugos/vaizdu-irasu-saugojimas'
                }
            ]
        }
    ]
};

export default vmaServices;